<template>
  <div class="container-exibicao" :class="{ 'competencia-periodo-invalido': invalido }" @click="$refs.input.focus()">
    <span class="exibicao">
      <b>{{ filtro.name }}:</b>
      <input
        ref="input"
        type="text"
        class="competencia-periodo-input"
        v-mask="mascara"
        :placeholder="filtro.placeholder || 'MM/AAAA'"
        :value="text"
        @input="onInput"
        @keyup.enter="aplicarFiltro"
        @blur="aplicarFiltro"
      />
      <SVGIcon v-if="!filtro.fixo" iconName="icon-close" :size="8" @click.stop="excluirFiltro" />
    </span>
  </div>
</template>
<script>
import SVGIcon from '../../../SvgIcon.vue';

export default {
  emits: ['excluirFiltro'],
  components: {
    SVGIcon
  },
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      text: '',
      invalido: false,
      mascara: '##/####'
    };
  },
  computed: {
    campoMes() {
      return this.filtro.campo_mes;
    },
    campoAno() {
      return this.filtro.campo_ano;
    }
  },
  methods: {
    onInput(evento) {
      this.text = evento.target.value;
      this.invalido = false;
    },
    aplicarFiltro() {
      if (!this.text) {
        return this.excluirFiltro();
      }
      if (!this.competenciaValida()) {
        this.invalido = true;
        return;
      }

      this.invalido = false;
      const { mes, ano } = this.separaCompetencia(this.text);

      this.$aplicaFiltroEmURL(this.campoMes, mes, this.path);
      this.$store.commit('addFiltroAplicado', { filtro: this.campoMes, valor: mes });

      this.$aplicaFiltroEmURL(this.campoAno, ano, this.path);
      this.$store.commit('addFiltroAplicado', { filtro: this.campoAno, valor: ano });
    },
    excluirFiltro() {
      this.text = '';
      this.invalido = false;
      this.$removeFiltroDaURL(this.campoMes, this.path);
      this.$removeFiltroDaURL(this.campoAno, this.path);
      this.$store.commit('removeFiltroAplicado', this.campoMes);
      this.$store.commit('removeFiltroAplicado', this.campoAno);
      this.$emit('excluirFiltro', this.filtro.filtro, this.path);
    },
    competenciaValida() {
      if (!/^\d{2}\/\d{4}$/.test(this.text)) return false;

      const { mes, ano } = this.separaCompetencia(this.text);
      if (mes < 1 || mes > 12 || ano < 2000) return false;

      return this.respeitaCompetenciaReferencia(mes, ano);
    },
    respeitaCompetenciaReferencia(mes, ano) {
      const comparacao = this.filtro.comparar_com;
      if (!comparacao) return true;

      const aplicados = this.$store.state.filtroAplicados;
      const mesReferencia = aplicados[comparacao.campo_mes];
      const anoReferencia = aplicados[comparacao.campo_ano];
      if (!mesReferencia || !anoReferencia) return true;

      return ano * 12 + mes >= Number(anoReferencia) * 12 + Number(mesReferencia);
    },
    separaCompetencia(texto) {
      const [mesTexto, anoTexto] = texto.split('/');
      return { mes: Number(mesTexto), ano: Number(anoTexto) };
    },
    montaTexto(mes, ano) {
      return `${String(mes).padStart(2, '0')}/${ano}`;
    },
    refletirAplicados() {
      const aplicados = this.$store.state.filtroAplicados;
      const mes = aplicados[this.campoMes];
      const ano = aplicados[this.campoAno];

      if (mes && ano) {
        this.text = this.montaTexto(mes, ano);
      } else {
        this.text = '';
      }
    }
  },
  watch: {
    '$store.state.filtroAplicados': {
      handler() {
        this.refletirAplicados();
      },
      deep: true
    }
  },
  mounted() {
    this.refletirAplicados();
  }
}
</script>
